module.exports = __webpack_public_path__ + "img/02.c3990e62.png";